import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/OrganizationInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}`;
	}
	getResourceHealth(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/resource-health`, { resourceType: e }));
	}
};
//#endregion
export { n as OrganizationInternalResource };

//# sourceMappingURL=OrganizationInternalResource.js.map